module.exports = __webpack_public_path__ + "media/images/bnr-set-53fb2eae9dd88b1ea64ef516b41ce4ee.png";